import { RootState } from 'src/state/redux'
import { AccessTokenDataExtended } from 'src/state/redux/slice/authToken'
import { useSelector } from 'react-redux';

export const selAuthTokens = (state: RootState): AccessTokenDataExtended[] => state.authToken.records

export const useAuthTokens = (): AccessTokenDataExtended[] =>
  useSelector((state: RootState) => selAuthTokens(state));
